import { Person } from 'schema-dts';
import { useAtomValue } from 'jotai';
import { $CurrentAvailableArticleOrNull } from '@article/shared/atoms/current-article';
import { $CurrentAvailableArticleAuthorOrNull } from '@article/shared/atoms/current-article-author';
import { UserDetailUtil } from 'shared/models';
import { Region } from '@lemon8/web-app-shared/i18n';

export const useArticleAuthorJsonld = (): Person | null => {
  const article = useAtomValue($CurrentAvailableArticleOrNull);
  const author = useAtomValue($CurrentAvailableArticleAuthorOrNull);

  if (!article || !author) {
    return null;
  }

  return UserDetailUtil.JsonLD.getPersonJsonLD({ user: author, userRegion: article.articleRegion as Region });
};
